import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  setTakePhotoModalKind,
  notifyAboutProductOverPacked,
} from "actions/pack_gdn";
import { Button, Textarea } from "expano-components";
import { Modal } from "components";

import { ReactComponent as WarningIcon } from "icons/warning.svg";
import { ReactComponent as ImageIcon } from "icons/image.svg";

const InputField = (props) => (
  <Textarea
    {...props}
    input={{
      ...props.input,
      placeholder: props.placeholder,
    }}
  />
);

const ModalProductsOverPacked = ({
  handleClose,
  notifyAboutProductOverPacked,
  setTakePhotoModalKind,
  handleSubmit,
  submitting,
  over_pack_photo_url,
  match: {
    params: { id },
  },
}) => {
  const onSubmit = async ({ over_packed_description }) => {
    try {
      await notifyAboutProductOverPacked(id, over_packed_description);
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Zgłoś nadstan",
        icon: <WarningIcon />,
      }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <Button
            type="save"
            text="Zgłoś"
            disabled={!over_pack_photo_url || submitting}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <div className="m-b-20 text-center">
        {over_pack_photo_url && <img src={over_pack_photo_url} width="200px" className="m-b-20" style={{borderRadius: '8px'}} />}
        <button
          className="btn btn-default"
          onClick={() => setTakePhotoModalKind("over_pack_photo")}
        >
          <ImageIcon />
          {over_pack_photo_url ? (
            <span>Zaktualizuj zdjęcie produktów nadstanowych</span>
          ) : (
            <span>Zrób zdjęcie produktów nadstanowych</span>
          )}
        </button>
      </div>
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Field
          name="over_packed_description"
          component={InputField}
          label="Opis problemu"
          placeholder="Nadstan produktu o sku ..."
        />
      </form>
    </Modal>
  );
};

export default connect(
  ({
    pack_gdn: {
      data: { over_packed_description, over_pack_photo_url },
    },
  }) => ({
    over_pack_photo_url,
    initialValues: { over_packed_description },
  }),
  (dispatch) => ({
    setTakePhotoModalKind: (kind) => dispatch(setTakePhotoModalKind(kind)),
    notifyAboutProductOverPacked: (id, desc) =>
      dispatch(notifyAboutProductOverPacked(id, desc)),
  })
)(
  reduxForm({
    form: "issue-form",
    enableReinitialize: true,
  })(withRouter(ModalProductsOverPacked))
);
